/**
 * 本地开发环境配置
 * RippleX 项目 - 本地开发环境配置文件
 * 对应后端: local 环境 (localhost:3020)
 */

const config = {
  // 环境标识
  env: 'local',
  
  // API基础URL - 对应后端 local 环境
  apiBaseURL: 'http://localhost:3020/api/v1',
  
  // WebSocket URL
  wsBaseURL: 'ws://localhost:3020/api/v1/ws/connect',
  
  // 是否开启调试模式
  debug: true,
  
  // 是否显示详细日志
  verbose: true,
  
  // Mock接口是否启用
  mock: false,
  
  // 上传文件大小限制 (MB)
  maxUploadSize: 100,
  
  // 请求超时时间 (毫秒)
  requestTimeout: 30000,
  
  // 是否启用请求重试
  enableRetry: false,
  
  // 页面标题后缀
  titleSuffix: ' - RippleX[本地]',
  
  // 是否启用开发者工具
  enableDevTools: true,
  
  // 静态资源基础路径
  publicPath: '/',
  
  // 版本信息
  version: '1.2.1.1-local'
}

export default config

// 单独导出各个配置项，方便按需引入
export const {
  env,
  apiBaseURL,
  wsBaseURL,
  debug,
  verbose,
  mock,
  maxUploadSize,
  requestTimeout,
  enableRetry,
  titleSuffix,
  enableDevTools,
  publicPath,
  version
} = config
